import { Image, Popup, Swiper } from 'antd-mobile-v5';
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import BuyOptions from './BuyOptions';
import Tag from '../../components/common/Tag';
import { useCardOptions, } from '../../services/hooks';
import LoadingStatus from '../../components/FormTools/Loading';
import { getCardOptionNames } from './cardOptionUtils';
import ChangeEcardsDetail from './components/ChangeEcardsDetail'
import PublicWelfareIntro from './components/PublicWelfareIntro'
import StoryCard from './components/StoryCard'
import { getMinPriceOptions } from './cardOptionUtils';
import { CLUB_URL_DOMAIN } from '../../utils/env'
import {UClick} from '../../components/common/utils'
import { cardStories } from '../../utils/cardStories'

import styles from './BuyCards.module.css';

export default () => {
  const { push } = useHistory()
  const bannerRef = useRef(null);
  const [showBuyDialogue, setShowBuyDialogue] = useState(false);
  const [cardOptions, setCardOptions] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [currentStory, setCurrentStory] = useState(null)
  const memberCenterUrl = CLUB_URL_DOMAIN + '/pages-mine/mine/member-center'
  const { loading, data} = useCardOptions({
    onSuccess: (data) => {
      let minPriceOptions = getMinPriceOptions(data)
      const firstItem =  {
        id: 0,
        styleName: "ecard畅换卡",
        price: 39900,
        imageUrl: "https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/vip-card.png"
      }
      minPriceOptions.unshift(firstItem)
      minPriceOptions.forEach((option, index) => {
        option.id = index
      })
      setCardOptions(minPriceOptions)
    }
  });

  useEffect(() => {
    UClick('CardOption1')
  },[])

  useEffect(() => {
    setCurrentStory(null)
    const story = cardStories.find(s => cardOptions[selectedIndex] && cardOptions[selectedIndex].cardStockId && s.id === cardOptions[selectedIndex].cardStockId)
    if(story) {
      setCurrentStory(story)
    }
  }, [selectedIndex, cardOptions])

  const toAllPage = () => {
    push('/all_cards', { cardOptions })
  }

  const toClubMemberPage = () => {
    UClick('ClickActivateNowBtn');
    window.location.href = memberCenterUrl
  }

  const toggleCard = (index) => {
    UClick(`CardOption${index+1}`)
    setSelectedIndex(index)
    if(index === 0) bannerRef.current.swipeTo(0)
    else bannerRef.current.swipeTo(1)
  }

  const toBuyCards = () => {
    UClick('ClickBuyCardBtn');
    setShowBuyDialogue(true)
  }

  if(loading) return <LoadingStatus />;

  if(!data) return null;

  return (
    <div className={styles.container}>
      <div className={styles.flexible}>
        <Swiper allowTouchMove={false} ref={bannerRef}>
          <Swiper.Item key={0}>
            <Image src={require('../../assets/images/buy_cards/banner.png')} lazy />
          </Swiper.Item>
          <Swiper.Item key={1}>
            <Image src={require('../../assets/images/buy_cards/banner2.png')} lazy />
          </Swiper.Item>
        </Swiper>
        <div className={styles['card-options']}>
          <div className={styles['options-header']}>
            <div className={styles.title}>卡面选择</div>
            <div className={styles.extra} onClick={toAllPage}>查看所有卡片</div>
          </div>
          <div className={styles.options}>
            <Swiper 
              trackOffset={10}
              slideSize={80} 
              indicator={() => null}
              onIndexChange={index => toggleCard(index)}>
              {cardOptions.map((option, index) => <Swiper.Item className={styles['option-item']} key={index}>
                <div className={styles['card-wrapper']}>
                  <div style={{paddingBottom: '65.79%', position: 'relative'}}>
                    <img src={option.imageUrl} className={styles.card} />
                  </div>
                  <div className={styles.content}>
                    <div className={styles['card-name']}>{option.styleName}</div>
                    <div className={styles['price-box']}>
                      <span className={styles['small-text']}>￥</span>
                      <span className={styles.price}>{option.price/100}</span>
                      <span className={styles['small-text']}>起</span>
                    </div>
                  </div>
                </div>
              </Swiper.Item>)}  
            </Swiper>
          </div>
        </div>
        {selectedIndex === 0 && <ChangeEcardsDetail />}
        {currentStory && <StoryCard story={currentStory} />}
        {selectedIndex !== 0 && <PublicWelfareIntro />}
        <div className={styles.optionsArea} style={{display: 'none'}}>
          <div className={styles.options}>
            <div className={styles.label}>卡面</div>
            <div
              className={styles.opiton}
              onClick={() => {
                setShowBuyDialogue(true);
              }}
            >
              {getCardOptionNames(cardOptions).map(option => <Tag key={option}>{option}</Tag>)}
            </div>
          </div>
          <div className={styles.options}>
            <div className={styles.label}>类型</div>
            <div
              className={styles.opiton}
              onClick={() => {
                setShowBuyDialogue(true);
              }}
            >
              <Tag>环保实体卡</Tag>
              <Tag>环保电子卡</Tag>
            </div>
          </div>
        </div>
      </div>
      {selectedIndex === 0 ? <div className={styles.bottom}>
        <div className={styles.left}>
          <div className={styles['text-wrapper']}>
            <div className={styles['left-top']}>
              <div className={styles['price-symbol']}>￥</div>
              <div className={styles['price']}>399.00</div>
              <div className={styles['month']}>/12个月（30天/月）</div>
            </div>
            <div className={styles['left-bottom']}>即可加入PADI Club</div>
          </div>
        </div>
        <div className={styles.right}>
          <button className={styles.btn} onClick={toClubMemberPage}>立即开通</button>
        </div>
      </div> 
      : 
      <div className={styles.bottom}>
        <div className={styles.left}>
          <div className={styles['text-wrapper']}>
            <div className={styles['big-text']}>
              <img src={require('../../assets/images/buy_cards/icon-bottom.png')} className={styles.icon}/>
              购买卡面助力海洋公益
            </div>
            <div className={styles['small-text']}>卡片收益将用于捐助"PADI爱海洋"公益基金</div>
          </div>
        </div>
        <div className={styles.right}>
          <button className={styles.btn} onClick={toBuyCards}>点击购买</button>
        </div>
        <Popup
          visible={showBuyDialogue}
          forceRender
          destroyOnClose
          onMaskClick={() => setShowBuyDialogue(false)}
          position="bottom"
          bodyStyle={{
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            height: '80vh',
            padding: '8px 8px 0',
          }}
        >
          <BuyOptions cardOptions={data}/>
        </Popup>
      </div>}
    </div>
  );
};
